import { render, staticRenderFns } from "./CardWidget.vue?vue&type=template&id=4c7cde5a&scoped=true"
import script from "./CardWidget.vue?vue&type=script&lang=js"
export * from "./CardWidget.vue?vue&type=script&lang=js"
import style0 from "./CardWidget.vue?vue&type=style&index=0&id=4c7cde5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7cde5a",
  null
  
)

export default component.exports